import { useMemo } from "react";

import createStore from "@Stores/base-factories";
import { hookCustomFieldsList, hookPostList, hookMetaFieldList } from "@Stores/base-factories/store-list";
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const useOfferFactory = ({ fetch, siteSelected: { id: siteId, key: siteKey }, collection: { collectionURL } }) => useMemo(() => ({
  getReferences: async offerId => await fetch({
    method: 'get',
    url: `${collectionURL}/${offerId}/references`,
    params: { [siteKey]: siteId },
  }),
  getPosts: async () => await fetch({
    method: 'get',
    url: `cms/posts`,
    params: { [siteKey]: siteId },
  }),
}), [collectionURL, fetch, siteKey, siteId])

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('site_id'))
  .extendHookCollectionFactory('offer')
  .extendHookCollectionsFactory('offers')
  .extend(hookCustomFieldsList())
  .extend(hookPostList('posts'))
  .extend(hookMetaFieldList())
  .extend(useOfferFactory)
  .factory()

export {
  Provider as OfferProvider,
  useStore as useOfferStore,
}
